import DummyLogo from "@/assets/images/lucidity-placeholder.png";
import { Badge } from "@/components/ui/badge";
import { Drawer, DrawerContent, DrawerTrigger } from "@/components/ui/drawer";
import { getMyStartupList } from "@/services/api/Startup";
import {
  Bank,
  Check,
  ClockCounterClockwise,
  PiggyBank,
  RocketLaunch,
  UserCheck,
} from "@phosphor-icons/react/dist/ssr";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";
import NotFound from "@/assets/images/not-found.png";
import { getMyVCList } from "@/services/api/VentureCapital";

export default function DrawerMyAngel() {
  const [info, setInfo] = useState(null);
  const getVCDetail = async () => {
    const response = await getMyVCList({
      params: {
        is_angel: true,
      },
    });
    setInfo(response.data.data[0]);
  };

  useEffect(() => {
    getVCDetail();
  }, []);

  const tools = [
    {
      name: "View Profile",

      icon: <Bank weight='duotone' className='text-orange-700 size-7' />,
      url: `/angel-investors/${info?.slug}-${info?.id}`,
    },
    {
      name: "Pitch Bank",

      icon: <PiggyBank weight='duotone' className='text-orange-700 size-7' />,
      url: "/account/angel",
    },
    {
      name: "Manage Access",

      icon: <UserCheck weight='duotone' className='text-orange-700 size-7' />,
      url: "/account/access-angel-investor",
    },
  ];
  return (
    <Drawer>
      <DrawerTrigger asChild>
        <button
          type='button'
          className='flex flex-col items-center gap-[3px] focus:outline-none'
        >
          <Bank weight='duotone' className='mx-auto text-2xl' />
          Angel Profile
        </button>
      </DrawerTrigger>
      <DrawerContent
        className='text-sm font-medium tracking-tight text-left bg-white border-b border-background/10 text-background/50 rounded-t-3xl'
        showHandle={false}
      >
        <div>
          <div className='flex justify-between px-4 pt-4 pb-2.5 border-b border-background/10'>
            <span className='w-1/3'></span>
            <p className='text-sm font-semibold tracking-tight text-center text-background/50'>
              My Angel Profile
            </p>
            <span className='flex justify-end w-1/3'>
              {!info?.is_published ? (
                <Badge className='text-[11px] !py-1 pl-1 font-semibold leading-none border-0 bg-gradient-to-tr from-green-300 to-green-600 text-white'>
                  <span className='inline-flex items-center justify-center mr-1.5 text-green-500 bg-white rounded-full size-3.5'>
                    <Check weight='bold' className='text-[10px]' />
                  </span>
                  Published
                </Badge>
              ) : (
                <Badge className='text-[11px] !py-1.5 font-semibold leading-none border-gray-200 text-background/50'>
                  Unpublished
                </Badge>
              )}
            </span>
          </div>

          <div className='px-3 pt-3'>
            <div className='flex items-center justify-between gap-3'>
              <span className='relative inline-flex overflow-hidden border border-gray-200 shadow-sm rounded-xl aspect-square size-12'>
                <Image
                  src={info?.logo_url || DummyLogo}
                  className='object-cover'
                  layout='fill'
                />
              </span>
              <div className='flex flex-col items-start flex-1 text-background'>
                <span className='text-lg font-bold'>{info?.name}</span>
                <span className='text-xs opacity-40'>
                  {info?.sectors?.map((sector) => sector.name).join(", ")}
                </span>
              </div>
            </div>
            <div className='py-1 mt-2 divide-y divide-background/10 divide-dashed'>
              {tools.map((tool, i) => (
                <Link
                  href={tool.url}
                  className='flex items-center gap-3 py-2'
                  key={i}
                >
                  {tool.icon}
                  <span className='text-base font-semibold leading-none tracking-tight text-background'>
                    {tool.name}
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
